module.exports = __webpack_public_path__ + "341104b9c6fa42798413709a9585ce11.svg";